import React from "react";
import { AccessibleFocusOutline } from "./AccessibleFocusOutline";
import DelayLink from "./DelayLink";
import { ChevronLeft } from "../common/IconsV2";

export const BackLink = ({
	to,
	onClick,
	textOverride,
	delay,
	onDelayStart,
	variant,
	disabled,
	fullWidth,
	smaller,
}) => {
	const variantClasses = () => {
		switch (variant) {
			case "navigationButton":
				return "pointerCursor text-black navigation-back-button";
			case "navigationText":
				return "flex align-center items-center justify-start pointerCursor text-sm text-black text-right font-bold leading-snug";
			case "inactive":
				return "inactive-button";
			case "active":
				return "active-button";
			default:
				//Previous default style
				return `block uppercase text-center px-3 py-2 rounded-lg w-full flex flex-row justify-center items-center font-bold`;
		}
	};

	return (
		<AccessibleFocusOutline classes={"w-full"}>
			<DelayLink
				delay={delay}
				onDelayStart={onDelayStart}
				to={{
					pathname: to,
					state: {
						isFromBackLink: true,
					},
				}}
				onClick={onClick}
			>
				{variant === "navigationText" ? (
					<div disabled={disabled} className={`${variantClasses()}`}>
						<ChevronLeft className={"inline-block w-3.5 mr-2.5"} />
						{textOverride ? textOverride : "Back"}
					</div>
				) : (
					<button className={`${variantClasses()} font-bold`}>
						{textOverride ?? "Back"}
					</button>
				)}
			</DelayLink>
		</AccessibleFocusOutline>
	);
};
